import { API } from '../main'
const prefix = '/user'

const postUserLoginCode = (phone) => {
    return API(localStorage.getItem('userToken')).post(`${prefix}/loginByCode`, {
        login: phone,
    })
}

const postUserConfirmCode = (phone, token) => {
    return API(localStorage.getItem('userToken')).post(`${prefix}/loginByCodeConfirmation`, {
        login: phone,
        confirmToken: token,
    })
}

const postUserConfirmPassword = (login, password) => {
    return API(localStorage.getItem('userToken')).post(`${prefix}/loginByPassword`, {
        login: login,
        password: password,
    })
}

const getUser = (id) => {
    if (id) {
        return API(localStorage.getItem('userToken')).get(`${prefix}/${id}`)
    } else {
        return API(localStorage.getItem('userToken')).get(`${prefix}/`)
    }
}

export { getUser, postUserConfirmCode, postUserConfirmPassword, postUserLoginCode }
